module.exports = __webpack_public_path__ + "static/img/tab222.1a1daec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabimg/tab222.png
// module id = EF8Z
// module chunks = 1